import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store/reducers";
//import { backSteep } from "../../store/actions/fichaMedicaActions";
import Api from "../../utils/api";
import { useParams } from "react-router-dom";
import Button from "../Button";
import IFichaCargaMedica from "../../interfaces/IFichaMedicaCarga";
import { setDatos } from "../../store/actions/fichaMedicaActions";
import OBJtoXML from "../../utils/objToXML";
import NACIONALIDADES from "../../data/nacionalidades";

export default function DatosDelPasajero() {
  const fichaMedica = useSelector((state: RootState) => state.fichaMedica);
  const [apiMessage, setApiMessage] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [fechaVencimiento, setFechaVencimiento] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [sexo, setSexo] = useState("");
  const [telefonoFijoDDN, setTelefonoFijoDDN] = useState("");
  const [telefonoFijo, setTelefonoFijo] = useState("");
  const [telefonoMovilDDN, setTelefonoMovilDDN] = useState("");
  const [telefonoMovil, setTelefonoMovil] = useState("");
  const [nacionalidad, setNacionalidad] = useState("");
  const [mail, setMail] = useState("");
  const [provincia, setProvincia] = useState("");
  const [localidad, setLocalidad] = useState("");
  const [codigoPostal, setCodigoPostal] = useState("");
  const [calle, setCalle] = useState("");
  const [estatura, setEstatura] = useState("");
  const [peso, setPeso] = useState("");

  const { id = "-1" } = useParams();
  const dispatch = useDispatch();

  // Sincroniza el estado local (campos controlados) desde redux cada vez que
  // cambia la ficha. Así la página 1 siempre refleja los datos guardados, aun
  // al avanzar y volver entre pasos (antes usaba defaultValue, que no se
  // actualiza después del montaje y por eso "se perdían" los datos).
  useEffect(() => {
    const c = fichaMedica.campos;
    setFechaVencimiento(c.F_VEN_DOCUMENTO || "");
    setFechaNacimiento(c.F_NACIMIENTO || "");
    setSexo(c.C_SEXO || "");
    setTelefonoFijoDDN(c.N_TEL_DDN || "");
    setTelefonoFijo(c.N_TEL_NRO || "");
    setTelefonoMovilDDN(c.N_CEL_DDN || "");
    setTelefonoMovil(c.N_CEL_NRO || "");
    setNacionalidad(c.C_NACIONALIDAD || "");
    setMail(c.D_MAIL || "");
    setProvincia(c.C_PROVINCIA || "");
    setLocalidad(c.D_LOCALIDAD || "");
    setCodigoPostal(c.C_POSTAL || "");
    setCalle(c.D_CALLE || "");
    setEstatura(c.ESTATURA || "");
    setPeso(c.PESO || "");
  }, [fichaMedica]);

  function handleClickValidar() {
    setApiMessage("");
    setIsFetching(true);
    const fvencimiento = fechaVencimiento.match(/^(\d+)-(\d+)-(\d+)$/);
    let tvencimiento = "";
    if (fvencimiento) {
      tvencimiento = `${fvencimiento[3]}/${fvencimiento[2]}/${fvencimiento[1]}`;
    }

    const fnacimiento = fechaNacimiento.match(/^(\d+)-(\d+)-(\d+)$/);
    let tnacimiento = "";
    if (fnacimiento) {
      tnacimiento = `${fnacimiento[3]}/${fnacimiento[2]}/${fnacimiento[1]}`;
    }

    let obj: IFichaCargaMedica = fichaMedica;
    obj = {
      ...obj,
      campos: {
        ...obj.campos,
        F_VEN_DOCUMENTO: tvencimiento,
        C_NACIONALIDAD: nacionalidad,
        F_NACIMIENTO: tnacimiento,
        C_SEXO: sexo,
        D_MAIL: mail,
        C_PROVINCIA: provincia,
        D_LOCALIDAD: localidad,
        C_POSTAL: codigoPostal,
        D_CALLE: calle,
        N_TEL_DDN: telefonoFijoDDN,
        N_TEL_NRO: telefonoFijo,
        N_CEL_DDN: telefonoMovilDDN,
        N_CEL_NRO: telefonoMovil,
        ESTATURA: estatura,
        PESO: peso,
      },
      steep: 1,
    };
    Api("consumir")
      .post({
        servicio: "fichaMedicaSet",
        param: {
          pc_request: OBJtoXML({ FICHA_MEDICA: obj.campos }),
          pco_pasajero: id,
          pn_pagina: 1,
        },
      })
      .then((res) => {
        setIsFetching(false);
        if (res.mensaje.tipo === "E") {
          setApiMessage(res.mensaje.descripcion);
          return;
        }
        dispatch(setDatos(obj));
      });
  }

  return (
    <div className="container mb-5">
      <div className="row align-items-end">
        <div className="col-md-6 col-12 my-2">
          <span>Apellido:</span>
          <input
            maxLength={100}
            value={fichaMedica.campos.D_APELLIDO || ""}
            className="form-control"
            type="text"
            disabled
          />
        </div>
        <div className="col-md-6 col-12 my-2">
          <span>Nombre:</span>
          <input
            maxLength={100}
            value={fichaMedica.campos.D_NOMBRE || ""}
            className="form-control"
            type="text"
            disabled
          />
        </div>
        <div className="col-md-4 col-12 my-2">
          <span>Tipo de documento:</span>
          <select
            className="form-select"
            value={fichaMedica.campos.T_DOCUMENTO}
            disabled
          >
            {fichaMedica.docuementos.map((campo) => (
              <option key={campo.codigo} value={campo.codigo}>
                {campo.dato}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-4 col-12 my-2">
          <span>Número de documento:</span>
          <input
            className="form-control"
            type="number"
            value={fichaMedica.campos.N_DOCUMENTO || ""}
            disabled
          />
        </div>
        <div className="col-md-4 col-12 my-2">
          <span>Vencimiento del DNI:</span>
          <input
            onChange={(e) => setFechaVencimiento(e.target.value)}
            className="form-control"
            type="date"
            value={fechaVencimiento}
          />
        </div>
        <div className="col-md-4 col-12 my-2">
          <span>Nacionalidad:</span>
          <input
            onChange={(e) => setNacionalidad(e.target.value)}
            className="form-control"
            type="text"
            value={nacionalidad}
            list="nacionalidades-ficha"
            autoComplete="off"
            placeholder="Escribí para buscar..."
          />
          <datalist id="nacionalidades-ficha">
            {NACIONALIDADES.map((n) => (
              <option key={n} value={n} />
            ))}
          </datalist>
        </div>
        <div className="col-md-4 col-12 my-2">
          <span>Fecha de Nacimiento:</span>
          <input
            onChange={(e) => setFechaNacimiento(e.target.value)}
            className="form-control"
            type="date"
            value={fechaNacimiento}
          />
        </div>
        <div className="col-md-4 col-12 my-2">
          <span>Sexo:</span>
          <select
            onChange={(e) => setSexo(e.target.value)}
            className="form-select"
            value={sexo}
          >
            {fichaMedica.sexos.map((campo) => (
              <option key={campo.codigo} value={campo.codigo}>
                {campo.dato}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-4 col-12 my-2">
          <span>Estatura:</span>
          <input
            maxLength={10}
            value={estatura}
            onChange={(e) => setEstatura(e.target.value)}
            className="form-control"
            type="text"
          />
        </div>
        <div className="col-md-4 col-12 my-2">
          <span>Peso:</span>
          <input
            maxLength={10}
            value={peso}
            onChange={(e) => setPeso(e.target.value)}
            className="form-control"
            type="text"
          />
        </div>
        <div className="col-md-8 col-12 my-2">
          <span>Mail:</span>
          <input
            maxLength={100}
            value={mail}
            onChange={(e) => setMail(e.target.value)}
            className="form-control"
            type="email"
          />
        </div>
        <div className="col-md-4 col-12 my-2"></div>
        <div className="col-md-4 col-12 my-2">
          <span>Porvincia:</span>
          <select
            onChange={(e) => setProvincia(e.target.value)}
            className="form-select"
            value={provincia}
          >
            {fichaMedica.provincias.map((campo) => (
              <option key={campo.codigo} value={campo.codigo}>
                {campo.dato}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-4 col-12 my-2">
          <span>Localidad:</span>
          <input
            maxLength={100}
            value={localidad}
            onChange={(e) => setLocalidad(e.target.value)}
            className="form-control"
            type="text"
          />
        </div>
        <div className="col-md-4 col-12 my-2">
          <span>Código postal:</span>
          <input
            maxLength={4}
            value={codigoPostal}
            onChange={(e) => setCodigoPostal(e.target.value)}
            className="form-control"
            type="text"
          />
        </div>
        <div className="col-12 my-2">
          <span>Calle:</span>
          <input
            maxLength={100}
            value={calle}
            onChange={(e) => setCalle(e.target.value)}
            className="form-control"
            type="text"
          />
        </div>
        <div className="col-md-2 col-12 my-2">
          <span>Teléfono Fijo - (DDN):</span>
          <input
            maxLength={10}
            value={telefonoFijoDDN}
            onChange={(e) => setTelefonoFijoDDN(e.target.value)}
            className="form-control"
            type="tel"
          />
        </div>
        <div className="col-md-4 col-12 my-2">
          <span>Teléfono Fijo - (Número):</span>
          <input
            maxLength={10}
            value={telefonoFijo}
            onChange={(e) => setTelefonoFijo(e.target.value)}
            className="form-control"
            type="tel"
          />
        </div>
        <div className="col-md-2 col-12 my-2">
          <span>Teléfono Móvil - (DDN):</span>
          <input
            maxLength={10}
            value={telefonoMovilDDN}
            onChange={(e) => setTelefonoMovilDDN(e.target.value)}
            className="form-control"
            type="tel"
          />
        </div>
        <div className="col-md-4 col-12 my-2">
          <span>Teléfono Móvil - (Número):</span>
          <input
            maxLength={10}
            value={telefonoMovil}
            onChange={(e) => setTelefonoMovil(e.target.value)}
            className="form-control"
            type="tel"
          />
        </div>
      </div>
      <div className="text-center mt-4">
        <Button
          title="Continuar"
          onLoad={isFetching}
          onPress={handleClickValidar}
        />
      </div>
      {apiMessage ? (
        <div
          className="text-danger"
          dangerouslySetInnerHTML={{ __html: apiMessage }}
        ></div>
      ) : (
        <></>
      )}
    </div>
  );
}
